import {gsap} from "gsap";
import {HTH} from "../HTH";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHGameAssets} from "../HTHGameAssets";
import {ISymbolData, HTHSymbol, HTHSymbolStates} from "./HTHSymbol";
import {HTHHelper} from "../utils/HTHHelper";

export class HTHNormalSymbol extends HTHSymbol {

    // private _currentStateSprite: PIXI.Sprite;
    private _currentStateSpine: PIXI.spine.Spine;
    private _multiplierText: PIXI.BitmapText;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super(symbolData, state);

        this._currentStateSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset(symbolData.symName));
        this._currentStateSpine.state.setAnimation(0, this.symSize === 1 ? "idle" : this.symSize <= 5 ? `${this.symSize}split_idle` : "5split_idle", false);
        this._currentStateSpine.name = "currentStateSpine";
        this.init(symbolData);

    }

    public getSpineAnimation(symData: ISymbolData): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.addImage(symData.symName, this.symSize <= 4 ? this.symSize : 5);
        this._multiplierText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 12,
            letterSpacing: -35
        });
        this._multiplierText.alpha = 0;
        this.addChild(this._multiplierText);
        this.addSymbolMultiplier();
        this.symbolState = HTHSymbolStates.NORMAL;
        return tl;
    }

    public addImage(textureType: string, textureSize: number): void {
        this._currentStateSpine.state.setAnimation(0, textureSize === 1 ? "idle" : textureSize <= 5 ? `${textureSize}split_idle` : "5split_idle", false)

    }

    public symbolAnimChange(animName: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset(this.symName));
        if (this.children.length > 1) {
            this.addChildAt(spine, 1);
        } else {
            this.addChild(spine);
        }
        tl.add(HTHHelper.playSpineWithTimeline(spine, 0, `${animName}`));
        tl.add(() => {
            this.addImage(this.symName, +animName[5]);
            this.removeChild(spine);
            spine.destroy();
            this.symbolState = HTHSymbolStates.NORMAL;
        }, ">");
        return tl;
    }

    public init(symData: ISymbolData): HTHNormalSymbol {
        this.addChild(this._currentStateSpine);
        this.getSpineAnimation(symData);
        return this;
    }

    public removeAndDestroy(): void {
        if (this._multiplierText) {
            this.removeSymbolMultiplier();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }


    public explode(): gsap.core.Timeline {
        const explodeTl: gsap.core.Timeline = gsap.timeline();
        if (this.symbolState !== HTHSymbolStates.WIN_EXPLODE) {
            const spine: PIXI.spine.Spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("blast"));
            this.addChild(spine);
            // const winEffectAnim: TimelineSprite = this.getWinEffectAnim();
            this.symbolState = HTHSymbolStates.WIN_EXPLODE;
            explodeTl.add(HTHHelper.playSpineWithTimeline(spine, 0, "blast"));
            // explodeTl.add(<gsap.core.Timeline><unknown>winEffectAnim.getAnimationAutoShowHide());
            if (!this.isEnhancerSymbol && this.symName !== "RW") {
                explodeTl.to([this._currentStateSpine, this._multiplierText!], {
                    alpha: 0,
                    duration: 0.533
                }, "<");
            }
            explodeTl.add(() => {

                spine.destroy();
                // winEffectAnim.destroy();
                if (this && this.parent) {
                    if (!this.isEnhancerSymbol && this.symName !== "RW") {
                        this.removeAndDestroy();
                    }
                }
            });
        }
        return explodeTl;
    }

    public highlight(): gsap.core.Timeline {
        const highlightTl: gsap.core.Timeline = gsap.timeline();
        const winHighlightAnim: TimelineSprite = this.getWinHighlightAnim();
        highlightTl.add(<gsap.core.Timeline><unknown>winHighlightAnim.getAnimationAutoShowHide());
        highlightTl.add(() => {
            winHighlightAnim.destroy();
        });

        return highlightTl;
    }


    public removalExplode(): gsap.core.Timeline {
        const remExTL: gsap.core.Timeline = gsap.timeline();
        remExTL.to(this, {duration: 0.25});
        remExTL.add(() => {
            if (this) {
                if (!this.isEnhancerSymbol) {
                    this.removeAndDestroy();
                }
            }
        });
        return remExTL;
    }

    public splitMultiplier(size: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let orangeMulti: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 12,
            tint: 0xFFA500,
            letterSpacing: -35
        });

        tl.add(() => {
            this._multiplierText.addChild(orangeMulti);
            this._multiplierText.alpha = 1;
            orangeMulti.anchor = new PIXI.Point(0.5, 0);
            orangeMulti.alpha = 0;
            orangeMulti.text = this._multiplierText.text;
        }, 0)

        if (this.symSize > 4) {
            tl.to(this._multiplierText.scale, {x: 0.9, y: 0.9, duration: 0.333});
            tl.to(this._multiplierText.scale, {x: 1.4, y: 1.4, duration: 0.033});
            tl.add(() => {
                this._multiplierText.text = `x${size}`;
                orangeMulti.text = this._multiplierText.text;
                this._multiplierText.position.set(0, -66);
                this._multiplierText.anchor = new PIXI.Point(0.5, 0);
                this._multiplierText.maxWidth = 25;
            }, ">");
            tl.to(orangeMulti, {alpha: 1, duration: 0.001});
            tl.to(orangeMulti, {alpha: 0, duration: 0.165});

            tl.to([this._multiplierText.scale], {x: 0.9, y: 0.9, duration: 0.132}, "<")
            tl.to([this._multiplierText.scale], {x: 1, y: 1, duration: 0.033});
            tl.add(() => {
                this.removeChild(orangeMulti);
                orangeMulti.destroy();
            })

        }
        return tl;
    }

    public addSymbolMultiplier(): void {

        if (this.symSize > 4) {
            this._multiplierText.alpha = 1;
            this._multiplierText.position.set(0, -66);
            this._multiplierText.anchor = new PIXI.Point(0.5, 0);
            this.updateSymbolMultiplier(this.symSize);
        }
    }

    public updateSymbolMultiplier(value: number): void {
        this._multiplierText.text = "";
        this._multiplierText.text = `x${value}`;
        this._multiplierText.maxWidth = 25;

    }

    public removeSymbolMultiplier(): void {
        this.removeChild(this._multiplierText);
        this._multiplierText.destroy();
    }


    public addSplitEffect(size: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.symSize = this.symSize * 2;
        if (this.symName !== "EB" && this.symName !== "SA") {
            tl.add(this.symbolAnimChange(size * 2 <= 5 ? `split${size * 2}` : "split5"));
            tl.add(this.splitMultiplier(size * 2), "<");
            tl.add(() => {
                this.symbolState = this.symbolState !== HTHSymbolStates.NO_WIN ? HTHSymbolStates.NO_WIN : this.symbolState;
                // this.addImage(this.symName, this.symSize <= 4 ? this.symSize : 5);
            }, 0);
        }
        this.symbolState = HTHSymbolStates.NORMAL;
        return tl;
    }

    public setInteractive(val: boolean): void {
        this.setInteractiveOnItem(val, this._currentStateSpine);
    }

    public makeBlurFilter(blurX: number = 0, blurY: number = 0, durationForBlur: number = 0.01): gsap.core.Timeline {
        const blurTL: gsap.core.Timeline = gsap.timeline();
        if (blurX == 0 && blurY == 0) {
            blurTL.add(() => {
                this._currentStateSpine.filters = [];
            });
        } else {
            this._currentStateSpine.filters = []
            blurTL.to(this._currentStateSpine, {
                pixi: {blurX: blurX, blurY: blurY},
                duration: durationForBlur
            },0);
        }
        return blurTL;
    }

    private setInteractiveOnItem(val: boolean, item: PIXI.spine.Spine): void {
        item.interactive = val;
        item.buttonMode = val;
        if (val) {
            item.on("pointertap", () => HTH.miniPayTable.onClicked({
                dispObj: item,
                name: this.symName,
                size: this.symSize
            }));
        } else {
            item.off("pointertap");
        }
    }

}